module.exports = __webpack_public_path__ + "static/media/120.6ac79392.png";